// extracted by mini-css-extract-plugin
export var galerieContainer = "galerie-images-module--galerie-container--37d9b";
export var galerieImage = "galerie-images-module--galerie-image--37198";
export var galerieItemContainer = "galerie-images-module--galerie-item-container--6e242";
export var galerieItemDescription = "galerie-images-module--galerie-item-description--b2dfd";
export var galerieItemHeader = "galerie-images-module--galerie-item-header--01b4b";
export var galerieItemLink = "galerie-images-module--galerie-item-link--a330d";
export var galerieItemTitle = "galerie-images-module--galerie-item-title--a5161";
export var masonryGrid = "galerie-images-module--masonry-grid--37d17";
export var masonryGridColumn = "galerie-images-module--masonry-grid-column--d0682";